import React, { useContext } from 'react';
import { pick, prop } from 'ramda';
import { WebContent } from 'js/components/system/WebContent';
import { useAppSelector, useDeviceSelector } from 'js/store/hooks';
import { AppContext } from 'js/components/system/App/store/context';

import style from './AboveHeader.scss';

export const AboveHeader = () => {
    const { addLoadingPromise } = useContext(AppContext);

    const {
        aboveHeaderWcIdDesktop,
        aboveHeaderWcIdTablet,
        aboveHeaderWcIdMobile
    } = useAppSelector(pick([
        'aboveHeaderWcIdDesktop',
        'aboveHeaderWcIdTablet',
        'aboveHeaderWcIdMobile'
    ]));
    const formFactor = useDeviceSelector(prop('formFactor'));
    const wcID = {
        desktop: aboveHeaderWcIdDesktop,
        tablet: aboveHeaderWcIdTablet,
        mobile: aboveHeaderWcIdMobile
    }[formFactor];

    if (wcID) {
        return (
            <div className={style.container}>
                <WebContent id={wcID} addLoadingPromise={addLoadingPromise} />
            </div>
        );
    }

    return null;
};
